import { Injectable } from '@angular/core';

const OFFER_EVENTS = ['debt.offer.created', 'debt.offer.agreed', 'debt.offer.applied', 'debt.offer.countered'];
const PROMISE_EVENTS = ['debt.promise.created', 'debt.promise.fulfilled', 'debt.promise.broken'];

@Injectable({
  providedIn: 'root'
})
export class DebtNotificationRouterService {

  routeFor(data: Record<string, any> | null | undefined): string | null {
    const event = String(data?.['event'] ?? data?.['type'] ?? '').trim();
    if (!event) {
      return null;
    }
    if (OFFER_EVENTS.includes(event)) {
      const offerId = Number(data?.['offerId']);
      return Number.isInteger(offerId) && offerId > 0 ? `/offers/${offerId}` : '/offers';
    }
    if (PROMISE_EVENTS.includes(event)) {
      return '/promise';
    }
    if (event === 'debt.settled') {
      return '/debt-free';
    }
    if (event === 'debt.payment.applied') {
      return '/insights';
    }
    return null;
  }
}
